import Vue from 'vue'
import App from 'App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Auth from '@websanova/vue-auth'
import VueAuthHttp from '@websanova/vue-auth/drivers/http/axios.1.x'
import VueAuthRouter from '@websanova/vue-auth/drivers/router/vue-router.2.x'
import VueNativeSock from 'vue-native-websocket'
import Vuelidate from 'vuelidate'
import VueSimpleAlert from 'vue-simple-alert'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import vSelect from 'vue-select'
import VueEditor from 'vue2-editor'
import VueMathjax from 'vue-mathjax'

import router from '@/router'
import store from '@/store/store'

import titleMixin from '@/mixins/titleMixin'

import '@/assets/css/reset.css'
import '@/assets/css/animate.css'
import '@/assets/scss/global.scss'

// import FlashMessage from '@/components/shared/FlashMessage'

// Componentes globais da aplicação
import Notification from './components/shared/Notification'
Vue.component('Notification', Notification)
Vue.use(VueEditor)
Vue.use(VueAxios, axios)
Vue.use(Vuelidate)
Vue.use(VueSimpleAlert, { confirmButtonText: 'Sim', cancelButtonText: 'Cancelar' })
Vue.component('multiselect', Multiselect)
Vue.component('v-select', vSelect)
// Vue.component('flash-message', FlashMessage)
Vue.mixin(titleMixin)
Vue.use(VueMathjax)

Vue.config.productionTip = false

Vue.prototype.$relatorio = process.env.VUE_APP_TEMA_API

Vue.axios.defaults.baseURL = process.env.VUE_APP_ROOT_API
Vue.axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'

Vue.router = router

Vue.use(Auth, {
	auth: {
		request: function (req, token) {
			this.options.http._setHeaders.call(this, req, { 'repov4-token': token })
		},
		response: function (res) {
			const headers = res.data
			return headers.token
		}
	},
	fetchData: { url: '/usuarios/minha_conta', method: 'GET' },
	http: VueAuthHttp,
	router: VueAuthRouter,
	tokenDefaultName: 'repov4-token',
	rolesVar: 'perfil',
	authRedirect: { path: '/login' },
	forbiddenRedirect: { path: '/login' },
	parseUserData: function (data) {
		return data
	},
	refreshData: {
		enabled: false
	},
	tokenExpired: function () {
		return false
	}
})

Vue.use(VueNativeSock, process.env.VUE_APP_WEBSOCKET_API, { connectManually: true })
Vue.use(VueNativeSock, process.env.VUE_APP_WEBSOCKET_API_QUESTOES, { connectManually: true })

new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App)
}).$mount('#app')
